import { render, staticRenderFns } from "./calendarEventModal.vue?vue&type=template&id=4fd5bbb1&"
import script from "./calendarEventModal.vue?vue&type=script&lang=js&"
export * from "./calendarEventModal.vue?vue&type=script&lang=js&"
import style0 from "./calendarEventModal.vue?vue&type=style&index=0&id=4fd5bbb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports